import { Controller } from "@hotwired/stimulus";

export default class extends Controller { 
  static targets = ["loader"];

  startLoading() {
    $('.ga-properties-details').css('opacity', '0');
    $('.refresh-ga-properties').css({'pointer-events': 'none', 'color': '#aaa'});
    $(this.loaderTarget).show();
  }
}
